export const questions: Array<[string, string]> = [
  [
    'Who is it for?',
    'Operations, HSE and risk professionals, site and maintenance engineers, environmental managers and students in mining, oil & gas, energy, agriculture, logistics and infrastructure.',
  ],
  [
    'Content depth?',
    'Professional level: from ENSO fundamentals and forecast reading to site-level flood, heat, drought and energy risk management, continuity planning and emergency response.',
  ],
  [
    'International?',
    'Yes. It covers El Niño impacts across regions worldwide and uses general, internationally applicable concepts. Always confirm local decisions with your national meteorological service and local regulations.',
  ],
  ['Format?', 'Digital PDF volumes with instant access after purchase.'],
  ['Currency?', 'The price is shown in USD and you can pay from any country.'],
  ['Not satisfied?', 'You have a 7-day guarantee with a 100% refund.'],
];
